import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'reactstrap'
import { request } from '../../../Redux/Sagas/requests/api'
import { isSuccessResponse } from '../../../helper'
import { fetchUpdateApiData } from '../../../Redux/Reducers/CMS'
import { AvField, AvForm } from 'availity-reactstrap-validation'

const ApproveEmail = ({ gridRelatedData }) => {
  const [value, updateValue] = useState(gridRelatedData?.savedFilters?.email_email_renewal?.['-filter-title'])
  const dispacth = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const currentRow = useSelector((state) => state.CMS.currentRow)

  const onApprove = (approveAll) => {
    let payload = {
      item_date_time_id: currentRow?.[0]?.id,
    }
    if (approveAll) {
      payload.all = true
    } else {
      const item_ids = gridRelatedData?.gridSelectedRow?.map((item) => item?.original?.id)
      payload = {
        ...payload,
        item_ids: item_ids,
      }
    }
    setIsLoading(true)
    request('renewal-locations/approve-renewal-email', 'POST', payload).then((res) => {
      isSuccessResponse(res, 'Email approved successfully!')
      setIsLoading(false)
      dispacth(fetchUpdateApiData())
    })
  }

  return (
    <div>
      <div>
        <Button
          size='sm'
          color='warning'
          className='text-white mr-2'
          onClick={() => onApprove()}
          disabled={isLoading || gridRelatedData?.gridSelectedRow?.length === 0}>
          Approve Selected Email
        </Button>
        <Button size='sm' color='success' onClick={() => onApprove(true)} disabled={isLoading || gridRelatedData?.gridData?.data?.length === 0}>
          Approve all Email
        </Button>
      </div>
      <div className='mt-2' style={{ width: '60%' }}>
        <AvForm
          onValidSubmit={(e, values) => {
            updateValue(values?.title)
            gridRelatedData?.getBySearch(
              {
                '-filter-title': values?.title,
              },
              []
            )
          }}>
          <label className='subtitle1 font-weight-bold'>Search by title,message</label>
          <AvField name='title' placeholder='Search' value={value} />
        </AvForm>
      </div>
    </div>
  )
}

export default ApproveEmail
